<template>
  <component :is="layout">
    <router-view />
  </component>
</template>
<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import MainLayout from '@/components/layout/MainLayout.vue';

const route = useRoute();

// Si la ruta tiene meta.layout = 'empty', no usamos layout.
// Si no, usamos MainLayout por defecto.
const layout = computed(() => {
  return route.meta.layout === 'empty' ? 'div' : MainLayout;
});
</script>